import { render } from "./FaqSection.vue?vue&type=template&id=9364833a&scoped=true"
const script = {}

import "./FaqSection.vue?vue&type=style&index=0&id=9364833a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9364833a"]])

export default __exports__